// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Filter field (native input, not Materialize, so no floating-label rules needed) === */
#planets-menu .planets-filter {
  padding: var(--kt-space-2) var(--kt-space-2) 0;
}

#planets-menu .planets-filter-input {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  margin: 0;
  padding: 0 var(--kt-space-3);
  color: var(--kt-text-primary);
  background: var(--kt-bg-elevated);
  border: 1px solid var(--kt-border-default);
  border-radius: var(--kt-radius-sm, 4px);
  font-size: var(--kt-font-sm);
  transition: border-color var(--kt-duration-fast) var(--kt-easing-default);
}

#planets-menu .planets-filter-input::placeholder {
  color: var(--kt-text-tertiary);
}

#planets-menu .planets-filter-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 1px var(--color-primary);
}

/* === Body rows: tighten the list so each kt-action sits flush in the card === */
#planets-menu .planets-section-list {
  display: flex;
  flex-direction: column;
}

/* === Moons: indented under the body they orbit ===
 * The list runs Sun-outward, so a moon has to read as belonging to the planet above it
 * rather than as the next thing further out. Indent plus a hairline leading rule does that
 * without an extra nested container per planet. */
#planets-menu .planets-menu-satellite {
  padding-left: var(--kt-space-6, 24px);
  position: relative;
}

#planets-menu .planets-menu-satellite .kt-action-label {
  color: var(--kt-text-secondary);
  font-size: var(--kt-font-sm);
}

#planets-menu .planets-menu-satellite::before {
  content: '';
  position: absolute;
  left: var(--kt-space-3, 12px);
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--kt-border-subtle, var(--kt-border-default));
}

/* An indented row that is the active body still needs its accent bar to read, so keep the
 * label at full contrast there. */
#planets-menu .planets-menu-satellite.planets-menu-active .kt-action-label {
  color: var(--kt-text-primary);
}

/* === Active (currently centered) body === */
/* Signal "active" with a brand-red left accent bar (a border, where the saturated
 * red reads cleanly) and keep the label near-white for contrast. Do NOT color the
 * label red: brand red (#ba160c) on the lightened active background fails contrast. */
#planets-menu .planets-menu-item.planets-menu-active {
  background-color: var(--kt-bg-active);
  box-shadow: inset 3px 0 0 0 var(--color-primary);
}

#planets-menu .planets-menu-item.planets-menu-active .kt-action-label {
  color: var(--kt-text-primary);
  font-weight: 600;
}

/* === Disabled (planned for future) bodies === */
#planets-menu .planets-menu-disabled {
  opacity: var(--disabledOpacity, 0.4) !important;
  cursor: var(--disabledCursor, not-allowed) !important;
  color: var(--kt-text-tertiary);
  user-select: none !important;
}

/* The CSS chevron is meaningless on a non-actionable row. */
#planets-menu .planets-menu-disabled::after {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/planets-menu/planets-menu.css"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;EACjC,0CAA0C;EAC1C,uCAAuC;EACvC,4BAA4B;EAC5B,yEAAyE;AAC3E;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;kDAGkD;AAClD;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,MAAM;EACN,SAAS;EACT,UAAU;EACV,6DAA6D;AAC/D;;AAEA;kCACkC;AAClC;EACE,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;;sFAEsF;AACtF;EACE,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;EACE,aAAa;AACf","sourcesContent":["/* === Filter field (native input, not Materialize, so no floating-label rules needed) === */\n#planets-menu .planets-filter {\n  padding: var(--kt-space-2) var(--kt-space-2) 0;\n}\n\n#planets-menu .planets-filter-input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  margin: 0;\n  padding: 0 var(--kt-space-3);\n  color: var(--kt-text-primary);\n  background: var(--kt-bg-elevated);\n  border: 1px solid var(--kt-border-default);\n  border-radius: var(--kt-radius-sm, 4px);\n  font-size: var(--kt-font-sm);\n  transition: border-color var(--kt-duration-fast) var(--kt-easing-default);\n}\n\n#planets-menu .planets-filter-input::placeholder {\n  color: var(--kt-text-tertiary);\n}\n\n#planets-menu .planets-filter-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 1px var(--color-primary);\n}\n\n/* === Body rows: tighten the list so each kt-action sits flush in the card === */\n#planets-menu .planets-section-list {\n  display: flex;\n  flex-direction: column;\n}\n\n/* === Moons: indented under the body they orbit ===\n * The list runs Sun-outward, so a moon has to read as belonging to the planet above it\n * rather than as the next thing further out. Indent plus a hairline leading rule does that\n * without an extra nested container per planet. */\n#planets-menu .planets-menu-satellite {\n  padding-left: var(--kt-space-6, 24px);\n  position: relative;\n}\n\n#planets-menu .planets-menu-satellite .kt-action-label {\n  color: var(--kt-text-secondary);\n  font-size: var(--kt-font-sm);\n}\n\n#planets-menu .planets-menu-satellite::before {\n  content: '';\n  position: absolute;\n  left: var(--kt-space-3, 12px);\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--kt-border-subtle, var(--kt-border-default));\n}\n\n/* An indented row that is the active body still needs its accent bar to read, so keep the\n * label at full contrast there. */\n#planets-menu .planets-menu-satellite.planets-menu-active .kt-action-label {\n  color: var(--kt-text-primary);\n}\n\n/* === Active (currently centered) body === */\n/* Signal \"active\" with a brand-red left accent bar (a border, where the saturated\n * red reads cleanly) and keep the label near-white for contrast. Do NOT color the\n * label red: brand red (#ba160c) on the lightened active background fails contrast. */\n#planets-menu .planets-menu-item.planets-menu-active {\n  background-color: var(--kt-bg-active);\n  box-shadow: inset 3px 0 0 0 var(--color-primary);\n}\n\n#planets-menu .planets-menu-item.planets-menu-active .kt-action-label {\n  color: var(--kt-text-primary);\n  font-weight: 600;\n}\n\n/* === Disabled (planned for future) bodies === */\n#planets-menu .planets-menu-disabled {\n  opacity: var(--disabledOpacity, 0.4) !important;\n  cursor: var(--disabledCursor, not-allowed) !important;\n  color: var(--kt-text-tertiary);\n  user-select: none !important;\n}\n\n/* The CSS chevron is meaningless on a non-actionable row. */\n#planets-menu .planets-menu-disabled::after {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
